export default __webpack_public_path__ + "static/analysts_Logician_INTP_personality_header-429fe2f1775c6cd936eaaeac1fb84ec3.svg";